module.exports = __webpack_public_path__ + "img/lbs0005jp01.a980f533.jpg";